import { render } from "./RecommendedProductCard.vue?vue&type=template&id=f13d96be&scoped=true"
import script from "./RecommendedProductCard.vue?vue&type=script&lang=js"
export * from "./RecommendedProductCard.vue?vue&type=script&lang=js"

import "./RecommendedProductCard.vue?vue&type=style&index=0&id=f13d96be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13d96be"]])

export default __exports__